import type { GameEvent } from "@/types"

export const rhodesEvents: Record<string, GameEvent> = {
    "dlg-ri-mon3tr": {
        id: "dlg-ri-mon3tr",
        type: "dialog",
        dialogues: [
            {
                speaker: "map.speaker.mon3tr",
                expression: "normal",
                side: "left",
                text: "map.dialog.riMon3tr.d1",
            },
            {
                speaker: "map.speaker.mon3tr",
                expression: "happy",
                side: "left",
                text: "map.dialog.riMon3tr.d2",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "thinking",
                side: "right",
                text: "map.dialog.riMon3tr.d3",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.riMon3tr.d4",
            },
            {
                speaker: "map.speaker.mon3tr",
                expression: "normal",
                side: "left",
                text: "map.dialog.riMon3tr.d5",
            },
            {
                speaker: "map.speaker.mon3tr",
                expression: "happy",
                side: "left",
                text: "map.dialog.riMon3tr.d6",
            },
            {
                speaker: "map.speaker.mon3tr",
                expression: "happy",
                side: "left",
                text: "map.dialog.riMon3tr.d7",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.riMon3tr.d8",
            },
            {
                speaker: "map.speaker.amiya",
                expression: "normal",
                side: "left",
                text: "map.dialog.riMon3tr.d9",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.riMon3tr.d10",
            },
            {
                speaker: "map.speaker.savage",
                expression: "happy",
                side: "left",
                text: "map.dialog.riMon3tr.d11",
            },
        ],
        choices: [],
    },

    "dlg-ri-closure": {
        id: "dlg-ri-closure",
        type: "dialog",
        dialogues: [
            {
                speaker: "map.speaker.closure",
                expression: "normal",
                side: "left",
                text: "map.dialog.riClosure.d1",
            },
            {
                speaker: "map.speaker.closure",
                expression: "happy",
                side: "left",
                text: "map.dialog.riClosure.d2",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.riClosure.d3",
            },
            {
                speaker: "map.speaker.closure",
                expression: "normal",
                side: "left",
                text: "map.dialog.riClosure.d4",
            },
            {
                speaker: "map.speaker.closure",
                expression: "normal",
                side: "left",
                text: "map.dialog.riClosure.d5",
            },
            {
                speaker: "map.speaker.closure",
                expression: "normal",
                side: "left",
                text: "map.dialog.riClosure.d6",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.riClosure.d7",
            },
        ],
        choices: [],
    },

    "evt-ri-01": {
        id: "evt-ri-01",
        type: "event",
        description: "map.event.ri01.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.ri01.c1",
                resultText: "map.event.ri01.c1r",
                nextDialogues: [],
            },
            {
                id: "c2",
                text: "map.event.ri01.c2",
                resultText: "map.event.ri01.c2r",
                nextDialogues: [],
            },
        ],
    },

    "evt-ri-02": {
        id: "evt-ri-02",
        type: "event",
        description: "map.event.ri02.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.ri02.c1",
                resultText: "map.event.ri02.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "happy",
                        text: "map.event.ri02.cd",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.ri02.c2",
                resultText: "map.event.ri02.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "happy",
                        text: "map.event.ri02.cd",
                    },
                ],
            },
        ],
    },

    "evt-ri-03a": {
        id: "evt-ri-03a",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-3-1.png"),
        description: "map.event.ri03.desc",
        dialogues: [],
        autoAdvance: true,
        choices: [
            {
                id: "c1",
                text: "map.event.ri03.c1",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "happy",
                        text: "map.event.ri03a.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-ri-01",
    },

    "evt-ri-03b": {
        id: "evt-ri-03b",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-3-2.png"),
        description: "map.event.ri03.desc",
        dialogues: [],
        autoAdvance: true,
        choices: [
            {
                id: "c1",
                text: "map.event.ri03.c1",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "happy",
                        text: "map.event.ri03b.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-ri-02",
    },

    "evt-ri-04a": {
        id: "evt-ri-04a",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-4-1.png"),
        description: "map.event.ri04.desc",
        dialogues: [],
        autoAdvance: true,
        choices: [
            {
                id: "c1",
                text: "map.event.ri04.c1",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "happy",
                        text: "map.event.ri04a.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-ri-03",
    },

    "evt-ri-04b": {
        id: "evt-ri-04b",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-4-2.png"),
        description: "map.event.ri04.desc",
        dialogues: [],
        autoAdvance: true,
        choices: [
            {
                id: "c1",
                text: "map.event.ri04.c1",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "normal",
                        text: "map.event.ri04b.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-ri-04",
    },

    "evt-ri-05a": {
        id: "evt-ri-05a",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-5-1.png"),
        description: "map.event.ri05.desc",
        dialogues: [],
        autoAdvance: true,
        choices: [
            {
                id: "c1",
                text: "map.event.ri05.c1",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "normal",
                        text: "map.event.ri05a.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-ri-05",
    },

    "evt-ri-05b": {
        id: "evt-ri-05b",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-5-2.png"),
        description: "map.event.ri05.desc",
        dialogues: [],
        autoAdvance: true,
        choices: [
            {
                id: "c1",
                text: "map.event.ri05.c1",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "normal",
                        text: "map.event.ri05b.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-ri-06",
    },

    "evt-ri-06a": {
        id: "evt-ri-06a",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-6-1.png"),
        description: "map.event.ri06.desc",
        dialogues: [],
        autoAdvance: true,
        choices: [
            {
                id: "c1",
                text: "map.event.ri06.c1",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "normal",
                        text: "map.event.ri06a.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-ri-07",
    },

    "evt-ri-06b": {
        id: "evt-ri-06b",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-6-2.png"),
        description: "map.event.ri06.desc",
        dialogues: [],
        autoAdvance: true,
        choices: [
            {
                id: "c1",
                text: "map.event.ri06.c1",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "happy",
                        text: "map.event.ri06b.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-ri-08",
    },
}
